(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.benefitCarousel = {
    attach: function (context, settings) {

      $('.benefits-carousel', context).once('benefitCarousel').each(function () {
        var $carousel = $(this);
        var $slickTarget = $carousel.find('.field__items').first();

        if ($slickTarget.length && !$slickTarget.hasClass('slick-initialized')) {

          // --------------------------------------------
          // Initialize Slick
          // --------------------------------------------
          $slickTarget.slick({
            dots: true,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 15000,
            arrows: false,
            adaptiveHeight: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
            customPaging: function (slider, i) {
              return '<button class="progress-dot"><span class="progress-fill"></span></button>';
            }
          });

          // Revalidate Blazy after Slick init (ensures images load)
          if (window.blazy && typeof window.blazy.revalidate === 'function') {
            setTimeout(function() {
              window.blazy.revalidate();
            }, 100);
          }

          // --------------------------------------------
          // Add Pause/Play button via JS (Font Awesome)
          // --------------------------------------------
          if ($carousel.find('.carousel-toggle').length === 0) {
            $carousel.append(
              '<button class="carousel-toggle" aria-pressed="false">' +
                '<i class="fas fa-pause"></i>' +
              '</button>'
            );
          }

          // --------------------------------------------
          // Progress bar reset on slide change
          // --------------------------------------------
          $slickTarget.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-dots .progress-fill').css({
              'width': '0%',
              'transition': 'none'
            });
          });

          // --------------------------------------------
          // Progress bar animate after change
          // --------------------------------------------
          $slickTarget.on('afterChange', function (event, slick, currentSlide) {
            var $activeDot = $('.slick-dots li.slick-active .progress-fill');
            $activeDot.css({
              'width': '0%',
              'transition': 'none'
            });

            setTimeout(function () {
              $activeDot.css({
                'width': '100%',
                'transition': 'width 15000ms linear'
              });
            }, 50);
          });

          // --------------------------------------------
          // Initialize first progress bar animation
          // --------------------------------------------
          setTimeout(function () {
            $('.slick-dots li.slick-active .progress-fill').css({
              'width': '100%',
              'transition': 'width 15000ms linear'
            });
          }, 100);

          // --------------------------------------------
          // Pause / Play Button Logic (only active dot)
          // --------------------------------------------
          var isPaused = false;

          $carousel.find('.carousel-toggle').on('click', function () {
            var $btn = $(this);
            var $icon = $btn.find('i');
            var $activeFill = $('.slick-dots li.slick-active .progress-fill');

            if (!isPaused) {
              // Pause autoplay
              $slickTarget.slick('slickPause');
              isPaused = true;
              $btn.attr('aria-pressed', 'true');

              // Switch icon → play
              $icon.removeClass('fa-pause').addClass('fa-play');

              // Freeze only active progress bar
              if ($activeFill.length) {
                var computedWidth = window.getComputedStyle($activeFill[0]).width;
                $activeFill.css({
                  'transition': 'none',
                  'width': computedWidth
                });
              }

            } else {
              // Resume autoplay
              $slickTarget.slick('slickPlay');
              isPaused = false;
              $btn.attr('aria-pressed', 'false');

              // Switch icon → pause
              $icon.removeClass('fa-play').addClass('fa-pause');

              // Restart animation for active dot only
              if ($activeFill.length) {
                $activeFill.css({
                  'transition': 'none',
                  'width': '0%'
                });

                setTimeout(function () {
                  $activeFill.css({
                    'transition': 'width 15000ms linear',
                    'width': '100%'
                  });
                }, 50);
              }
            }
          });

          // Ensure autoplay is running at load
          $slickTarget.slick('slickPlay');
        }
      });
    }
  };

})(jQuery, Drupal);
